export type SignalObservation = 'waiting' | 'historical' | 'received';

/** Historical completions cannot validate an installation prepared more recently. */
export const signalObservation = (
  lastObservedAt?: string | null,
  preparedAt?: string | null,
): SignalObservation => {
  const observed = lastObservedAt ? Date.parse(lastObservedAt) : NaN;
  if (!Number.isFinite(observed)) {
    return 'waiting';
  }
  const prepared = preparedAt ? Date.parse(preparedAt) : NaN;
  return Number.isFinite(prepared) && observed < prepared
    ? 'historical'
    : 'received';
};
